import { useMutation, useQueryClient } from '@tanstack/react-query'
import apiClient from '@/apiClient'

export type PlanKey = 'MONTHLY_STANDARD' | 'YEARLY_ECO' | 'LIFETIME_PREMIUM'

export const useRequestPlanMutation = () => {
  const qc = useQueryClient()

  return useMutation({
    mutationFn: async (plan: PlanKey) => {
      const { data } = await apiClient.post('/owners/me/plan-request', { plan })
      return data
    },
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: ['owner'] })
      qc.invalidateQueries({ queryKey: ['subscription-payments'] })
    },
  })
}
